import { postAPI, callAPI } from "../services/api";

export const updateSitesSettings = async ({settingSelected, value, body}) => {
    try {
        const route = `/sites-settings/${settingSelected}/${value}`;
        const response = await postAPI("", route, body);
        return response;
    }
    catch(error){
        throw error;
    }
}

// Exclusion Products

export const getIngestExclusionProducts = async () => {
    try {
        const route = "/excludedProducts";
        const response = await callAPI(route);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateIngestExclusionProducts = async (data) => {
    try {
        const route = "/excludedProducts";
        const response = await postAPI("", route, {items: data});
        return response;
    } catch (error) {
        throw error;
    }
}

export const validateExcludedProduct = async (productId) => {
    try {
        const route = `/crossRefexcludedProduct/${productId}`;
        const response = await callAPI(route);
        return response;
    } catch (error) {
        throw error;
    }
}

// Exclusion License Plates

export const getExclusionLicensePlates = async () => {
    try {
        const route = "/excludedLicensePlates";
        const response = await callAPI(route);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateLicensePlateExclusion = async (data) => {
    try {
        const route = "/excludeLicenseAndState";
        const response = await postAPI("", route, {items: data});
        return response;
    } catch (error) {
        throw error;
    }
}